import { render, staticRenderFns } from "./supperSetting.vue?vue&type=template&id=2bb53d09&scoped=true&"
import script from "./supperSetting.vue?vue&type=script&lang=js&"
export * from "./supperSetting.vue?vue&type=script&lang=js&"
import style0 from "./supperSetting.vue?vue&type=style&index=0&id=2bb53d09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb53d09",
  null
  
)

export default component.exports